import React from 'react';

import css from './LocationAutocompleteInput.module.css';

const IconCurrentLocation = () => (
  <svg className={css.currentLocationIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_3705_19421)">
      <path d="M10.8335 0.833313L10.8343 3.38499C13.8495 3.76135 16.2392 6.15134 16.6152 9.16665H19.1668V10.8333L16.6152 10.8341C16.2388 13.8491 13.8492 16.2386 10.8343 16.615L10.8335 19.1666H9.16683V16.6151C6.15152 16.2391 3.76154 13.8493 3.38517 10.8341L0.833496 10.8333V9.16665H3.38507C3.7611 6.15105 6.15124 3.76091 9.16683 3.38489V0.833313H10.8335ZM10.0002 4.99998C7.23874 4.99998 5.00016 7.23855 5.00016 9.99998C5.00016 12.7614 7.23874 15 10.0002 15C12.7616 15 15.0002 12.7614 15.0002 9.99998C15.0002 7.23855 12.7616 4.99998 10.0002 4.99998ZM10.0002 8.33331C10.9207 8.33331 11.6668 9.07948 11.6668 9.99998C11.6668 10.9205 10.9207 11.6666 10.0002 11.6666C9.07966 11.6666 8.3335 10.9205 8.3335 9.99998C8.3335 9.07948 9.07966 8.33331 10.0002 8.33331Z" fill="#2E90FA" />
    </g>
    <defs>
      <clipPath id="clip0_3705_19421">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconCurrentLocation;
